import { constants, typographyStyles } from "@newsela/angelou";

import { greenWithOpacity } from "@/angelouCE/utils/constants";

const { colors } = constants;
const { textMObj } = typographyStyles;

export const containerCss = {
  marginBottom: "24px",
  listStyleType: "none",
};

export const multipleChoiceContainerCss = (isReadAloudButtonActive) => ({
  position: "relative",
  backgroundColor: colors.ui.neutral[25],
  borderRadius: isReadAloudButtonActive ? "4px 4px 0px 0px" : "4px",
});

export const multipleChoiceCss = {
  display: "flex",
  position: "relative",
  color: colors.ui.neutral[500],
  padding: "12px 16px",
};

export const multipleChoiceBackgroundCss = (
  isCorrectChoice,
  shouldRenderDefaultBackground,
) => {
  if (shouldRenderDefaultBackground) {
    return { backgroundColor: colors.ui.neutral[25] };
  }

  if (isCorrectChoice) {
    return {
      backgroundColor: greenWithOpacity,
    };
  } else {
    return { backgroundColor: colors.ui.neutral[50] };
  }
};

export const choiceLetterCss = {
  ...textMObj,
  fontWeight: "bold",
  marginRight: "16px",
};

export const choiceTextCss = {
  ...textMObj,
  whiteSpace: "pre-line",
};

export const multipleChoiceLabelCss = {
  position: "absolute",
  top: "-10px",
  left: "42px",
  fontWeight: "bold",
};
